<template>
    <div class="customer-order-component px-6 py-8 w-full">
        <div class="details grid mb-10">
            <div>
                <p class="font-bold mb-2">{{ trans.get('customer.order-status') }}</p>
                <span class="chip" :class="order.status">{{ trans.get('customer.' + order.status) }}</span>
            </div>
            <div>
                <p class="font-bold mb-1">{{ trans.get('customer.expected-delivery-date') }}</p>
                <p>{{ order.delivery_date }}</p>
            </div>
            <div>
                <p class="font-bold mb-1">{{ trans.get('customer.order-code') }}</p>
                <p>{{ order.code }}</p>
            </div>
            <div>
                <p class="font-bold mb-1">{{ trans.get('customer.order-date') }}</p>
                <p>{{ order.created_at }}</p>
            </div>
        </div>
        <div class="mb-10">
            <p class="font-bold mb-5">{{ productsCount }} {{ trans.choice('customer.article_s', productsCount) }}</p>
            <div class="images grid">
                <div v-for="product in order.products" :key="product.id" :title="product.pivot.product_name[lang]">
                    <img loading="lazy" v-if="product.images.length" class="image" :src="product.images[0].webp"/>
                    <img loading="lazy" v-else class="image" src="/img/no-image-placeholder.png"/>
                </div>
            </div>
        </div>
        <button @click="seeDetails" class="btn btn-primary block mx-auto">{{ trans.get('customer.see-details') }}</button>
    </div>
</template>

<script>
import mixin, { goToRouteWithName } from '../../mixin';

export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
    },

    mixins: [mixin, goToRouteWithName],

    computed: {
        productsCount() {
            return this.order.products.length;
        }
    },

    methods: {
        seeDetails() {
            this.$router.push({ name: 'customer.order-details', params: { code: this.order.code } });
        }
    },
}
</script>

<style lang="scss">
$light-orange: #ffc095;
$pale-lime: #b5eb8e;
$salmon: #ffa5a5;
$sandy-yellow: #f9f082;
$blue: lightblue;
$order-color: ("pending": $blue,"refunded" : $salmon, "delivered": $pale-lime, "sent":$sandy-yellow, "received": $light-orange);

.customer-area-page {
    .customer-order-component {
        box-shadow: 0 4px 13px 2px rgb(0 0 0 / 10%);
        max-width: 500px;

        .details {
            grid-template-columns: repeat(2, 1fr);
            gap: 2rem 1rem;
        }

        .images {
            gap: .5rem;
            grid-template-columns: repeat(auto-fit, 6rem);

            .image {
                width: 100%;
                height: 6rem;
                object-fit: contain;
                border: 1px solid #ccc;
            }
        }
    }
    .customer-order-component,
    .customer-order-details-component {
        .chip {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 1rem;
            padding: 0.6rem;

            @each $order, $color in $order-color {
                &.#{$order} {
                    background-color: #{$color};
                }
            }
        }
    }
}
</style>
